import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "19.2",
      height: "19.2",
      x: "9.066",
      y: "7.033",
      fill: "#2B63D9",
      opacity: ".15",
      rx: "9.6"
    }, null, -1),
    _createElementVNode("rect", {
      width: "17.619",
      height: "17.619",
      x: "9.324",
      y: "7.291",
      stroke: "#2B63D9",
      "stroke-width": "1.581",
      rx: "8.809"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#2B63D9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.309",
      d: "m13.77 16.972 2.711 2.618 6.016-6.982"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      "fill-rule": "evenodd",
      d: "M9.6 17.167H4.8a1.6 1.6 0 1 1 0-3.2h4.8z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }